import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Style/common.css";
import "./Style/header.css";
import "./Style/ChangeAvatar.css";
import Header from "../../Common/Header";
import Loading from "../../Common/Loading";
import CryptoJS from "crypto-js";

const SECRET_ENCRYPTION_KEY = "6GJZIa6J7NZzTdzf4K7Em6y6XiqwT09wqkKkNHaAvjE=";

function decrypt(encryptedBase64: string) {
  try {
    const key = CryptoJS.enc.Base64.parse(SECRET_ENCRYPTION_KEY);
    const cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(encryptedBase64),
    });

    const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });

    return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    console.error("Decryption failed:", error);
    return {};
  }
}


const ChangeAvatar: React.FC = () => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState<string>("");
  const [avatars, setAvatars] = useState<string[]>([]);
  const [
    // currentAvatar
    , setCurrentAvatar] = useState<string | null>(null);
  const [selectedAvatar, setSelectedAvatar] = useState<string | null>(null);
  const [isAvatarChanged, setIsAvatarChanged] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [saving, setSaving] = useState<boolean>(false);
  const [tickImageUrl, setTickImageUrl] = useState<string>("");

  // const apiUrl = process.env.REACT_APP_DOCUMENT_LINK || 'http://127.0.0.1:8000/';
  const apiUrl = process.env.REACT_APP_DOCUMENT_LINK ;

  useEffect(() => {
    const sessionUser = sessionStorage.getItem("FName");
    const sessionAvatar = sessionStorage.getItem("CurrentAvatar");

    if (sessionUser !== null) setUserName(sessionUser);
    if (sessionAvatar) {
      setSelectedAvatar(sessionAvatar);
      setCurrentAvatar(sessionAvatar);
    }

    fetch(`${apiUrl}ChangeAvatar/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        FamilyCode: sessionStorage.getItem("FamilyCode"),
        SchoolCode: sessionStorage.getItem("SchoolCode"),
        Login: sessionStorage.getItem("Login"),
      }),
    })
      .then((res) => res.json())
      .then((encryptedData) => decrypt(encryptedData.data))
      .then((decrypted) => {
        // console.log("decrypted", decrypted);
        if (decrypted.userName) setUserName(decrypted.userName);
        if (decrypted.currentAvatar) {
          setSelectedAvatar(decrypted.currentAvatar);
          setCurrentAvatar(decrypted.currentAvatar);
        }
        if (decrypted.avatars) setAvatars(decrypted.avatars);
        if (decrypted.tickImageUrl) setTickImageUrl(decrypted.tickImageUrl);
      })
      .catch((err) => console.error("Avatar load failed", err))
      .finally(() => setLoading(false));

    document.body.classList.add("StudyRoom-background");
    
    return () => {
      document.body.classList.remove("StudyRoom-background");
    };
  }, [apiUrl]);

const handleAvatarClick = (avatarUrl: string) => {
  setSelectedAvatar(avatarUrl);
  setIsAvatarChanged(true);
};

  const handleSave = async () => {
    if (!selectedAvatar) {
      navigate("/STUDENT/MSR/Profile");
      return;
    }

    setSaving(true);

    const payload = {
      SchoolCode: sessionStorage.getItem("SchoolCode"),
      FamilyCode: sessionStorage.getItem("FamilyCode"),
      Login: sessionStorage.getItem("Login"),
      AvatarTitle: selectedAvatar.split("/").pop()?.replace(/\.png$/i, "") || selectedAvatar,
    };

    try {
      await fetch(`${apiUrl}set_current_avatar/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
    } catch (err) {
      console.error("Failed to call set_current_avatar:", err);
    }

    sessionStorage.setItem("CurrentAvatar", selectedAvatar);
    navigate("/STUDENT/MSR/Profile");
  };

  const handleCancel = () => {
    window.location.href = "/STUDENT/MSR/Profile";
  };

  const handleBack = () => {
    window.location.href = "/STUDENT/MSR/Profile";
  };

  return (
    <form id="form1">
    <Header />

    <div className="change_avatar" style={{ height: "100vh", backgroundColor: "rgba(40, 40, 40, 0.995)" }}>
      <br />
      <p>
        <span className="title_text">Change avatar</span>
        
      </p>

      <div className="change_avatar_collection change_avatar_collectionT">
        {loading || saving ? (
          <Loading />
        ) : (
          avatars.map((avatar, index) => {
            const isSelected = selectedAvatar === avatar;
            const tickStyle = isSelected && tickImageUrl ? {
                backgroundImage: `url(${tickImageUrl})`
            } : {};
          
            return (
              <div
                id={`divAvatar_${index}`}
                key={index}
                className={`change_avatar_item ${isSelected ? "selected" : ""}`}
                style={{ backgroundImage: `url(${avatar})`, alignContent: "center" }}
                onClick={() => handleAvatarClick(avatar)}
              >
                <span id={`tick_check_${index}`} style={tickStyle}></span>
              </div>
            );
          })
        )}
      </div>

      <div className="button_box">
        {isAvatarChanged ? (
          <>
            <div
              id="change_avatar_cancel_btn"
              className="general_btn two_btn_lightbox two_btn_left"
              onClick={handleCancel}
              style={{ display: "inline-table" }}
            >
              <p id="lnkbtnCancel">Cancel</p>
            </div>
            <div
              id="change_avatar_save_btn"
              className="general_btn two_btn_lightbox"
              onClick={handleSave}
              style={{ display: "inline-table" }}
            >
              <p id="lnkbtnSave">Save</p>
            </div>
          </>
        ) : (
          <div
            id="change_avatar_back_btn"
            className="general_btn two_btn_lightbox single_btn"
            onClick={handleBack}
            style={{ display: "inline-table" }}
          >
            <p id="lnkbtnBack">Back</p>
          </div>
        )}
      </div>
    </div>
    </form>
  );
};

export default ChangeAvatar;
